import ProgressTester from './ProgressTester'

ProgressTester.install = function install (Vue) {
  Vue.component(ProgressTester.name, ProgressTester)
}

export default ProgressTester



// WEBPACK FOOTER //
// ./src/components/progress-tester/index.js